const status = {
  title: 'Battery status',
  meta: [],
}

const type = {
  title: 'Battery type',
  meta: [
    {
      key: 'manufacturer',
      label: 'Manufacturer',
      type: 'text',
    },
    {
      key: 'capacity',
      label: 'Capacity',
      type: 'double',
    },
    {
      key: 'voltage_per_unit',
      label: 'Voltage per unit',
      type: 'double',
    },
    {
      key: 'l_w_h',
      label: 'L x W x H (cm)',
      type: 'double',
    },
    {
      key: 'weight',
      label: 'Weight (kg)',
      type: 'text',
    },
    {
      key: 'maksimum_charging_current',
      label: 'Maksimum charging Current (A)',
      type: 'double',
    },
    {
      key: 'maksimum_discharging_current',
      label: 'Maksimum discharging Current (A)',
      type: 'double',
    },
    {
      key: 'blank',
      type: 'blank',
    },
    {
      key: 'blank',
      type: 'blank',
    },
    {
      key: 'documents',
      label: 'Document Att.',
      type: 'fileupload',
    },
  ],
}

export default {
  type: type,
  status: status,
}
